import {botanical, logo, nav} from '../data/site';

export function FinalCta() {
  return (
    <section className="final-cta">
      <div className="container final-cta-inner">
        <img src={botanical} alt="" aria-hidden="true" loading="lazy" />
        <div>
          <h2>Every Great Journey Starts with a Little Step.</h2>
          <p>Get in touch with Minrose and discover more about our center.</p>
        </div>
        <a href="#contact" className="button button-outline">Contact Minrose <span aria-hidden="true">→</span></a>
        <img src={botanical} alt="" aria-hidden="true" loading="lazy" />
      </div>
    </section>
  );
}

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <a href="#home" aria-label="Minrose home">
            <img src={logo} alt="Minrose Child Development Center logo" loading="lazy" />
          </a>
          <p>Nurturing children's growth, one step at a time.</p>
        </div>

        <div>
          <h3>Quick Links</h3>
          <div className="footer-links">
            {nav.map(([label, hash]) => <a key={hash} href={hash}>{label}</a>)}
          </div>
        </div>

        <div>
          <h3>Get in Touch</h3>
          <p>120A Marikkar Street,<br />Dharga Town 12090, Sri Lanka</p>
          <p><a href="tel:0704049404">070 404 9404</a></p>
          <p><a href="mailto:admin@minrosecdc.com">admin@minrosecdc.com</a></p>
          <p><a href="https://wa.me/94704049404">WhatsApp: +94 70 404 9404</a></p>
        </div>

        <div>
          <h3>Legal</h3>
          <a href="#privacy">Privacy Policy</a>
          <p>© {new Date().getFullYear()} Minrose Child Development Center.</p>
          <span>Minrosecdc.com</span>
        </div>
      </div>
    </footer>
  );
}